import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { sendPhone, sendCode, resetAuthState } from '../../../redux/reducer/slices/profileSlice';
import styled from "styled-components"
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import PinInput from '../../../components/PinInput';
import Title from '../../../components/Title';

const AuthForm = () => {
  const { appSettings } = useSelector((state) => state.common);
  const {
    sendPhoneStatus,
    isCodeValid,
  } = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  const [phone, setPhone] = useState(+7);
  const [sendCodeBy, setSendCodeBy] = useState('Telegram'); //  'SMS' || 'Telegram'
  const [time, setTime] = useState(60);
  const phoneInputRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (phoneInputRef.current) {
      phoneInputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  const onChangePhone = (value) => {
    setPhone(value);
  }

  const handleSendPhone = () => {
    dispatch(sendPhone({ phone: phone, SendCodeBy: sendCodeBy }));

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    setTime(60);
    timerRef.current = setInterval(() => {
      setTime((prevSeconds) => {
        if (prevSeconds > 1) {
          return prevSeconds - 1;
        } else {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return 0;
        }
      });
    }, 1000);
  };

  const onChangeCode = (code) => {
    if (code.length === 4) {
      dispatch(sendCode(code));
    }
  }

  const handleEditPhone = () => {
    dispatch(resetAuthState());
  };

  const handlePhonePushEnter = (event) => {
    if (event.key === 'Enter' && phone.length === 12) {
      handleSendPhone();
    }
  };

  return (
    <Wrapper>
      <Title>Вход на сайт</Title>
      {sendPhoneStatus !== 'fulfilled' ? (
        <Form>
          <FormItem>
            <FormLabel>Номер телефона</FormLabel>
            <Input
              type="phone"
              placeholder="+7"
              value={phone}
              onChange={onChangePhone}
              onKeyDown={handlePhonePushEnter}
              ref={phoneInputRef}
            />
          </FormItem>
          {appSettings.SendCodeBy.Telegram && (
            <FormItem>
              <RadioGroup>
                <RadioLabel>
                  <input
                    type="radio"
                    name="sendCodeBy"
                    value="Telegram"
                    checked={sendCodeBy === 'Telegram'}
                    onChange={(e) => setSendCodeBy(e.target.value)}
                  />
                  <span>в Telegram</span>
                </RadioLabel>
                <RadioLabel>
                  <input
                    type="radio"
                    name="sendCodeBy"
                    value="SMS"
                    checked={sendCodeBy === 'SMS'}
                    onChange={(e) => setSendCodeBy(e.target.value)}
                  />
                  <span>в СМС</span>
                </RadioLabel>
              </RadioGroup>
            </FormItem>
          )}
          <FormItem>
            <Button
              type='primary'
              onClick={handleSendPhone}
              disabled= {phone.length !== 12 || sendPhoneStatus === 'pending'}
            >
              Выслать код
            </Button>
          </FormItem>
        </Form>
      ) : (
        <Form>
          <FormItem>
            <FormLabel>
              <p>
                Код отправили сообщением<br/>
                на номер <b onClick={handleEditPhone} style={{ textDecoration: 'underline', cursor: 'pointer' }}>{phone}</b>
              </p>
            </FormLabel>
            <PinContainer>
              <PinInput
                  length={4}
                  focus
                  onComplete={onChangeCode}
                  type="numeric"
                  inputMode="number"
                  inputStyle={{
                      width: '60px',
                      height: '60px',
                      margin: '5px',
                      fontSize: '24px',
                      borderRadius: '16px',
                      borderColor: isCodeValid === false ? '#EA394B' : isCodeValid === true ? '#49BC9A' : '#EAEAEA',
                      backgroundColor: '#F9F9F9',
                  }}
              />
              <PinError>{isCodeValid === false ? 'код неверный' : ''}</PinError>
            </PinContainer>
          </FormItem>
                  {console.log('time', time)}
          <FormItem>
            <Button
              type='primary'
              onClick={handleSendPhone}
              disabled={time > 0}
            >
              {time > 0 ? `Получить новый код, ${time} сек` : `Получить новый код`}
            </Button>
          </FormItem>
        </Form>
      )}
      <UserAgreement>
        Продолжая, вы принимаете условия &nbsp;
        <br/>
        <a href="https://sitiy-api.ru/files/146923/static/userpolicy.html?time=164396005052412" target="_blank" rel="noopener noreferrer">
          <span style={{ color: '#54933F', textDecoration: 'underline', cursor: 'pointer' }}>“Пользовательским соглашением”</span>
        </a>
      </UserAgreement>
    </Wrapper>
  );
};

export default AuthForm;

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  min-width: 100%;
`;

const Form = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const FormLabel = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #2C2E32;
`;

const UserAgreement = styled.div`
  margin-top: 16px;
`;

const PinContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 0 16px;
`;

const PinError = styled.div`
    height: 16px;
    color: #EA394B;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 16px;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 16px;
  color: #2C2E32;

  input[type="radio"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    accent-color: #54933F;
  }

  span {
    user-select: none;
  }
`;